module.exports = __webpack_public_path__ + "static/img/shiwu_2x.fbc51bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shiwu_2x.png
// module id = GcgV
// module chunks = 1